import React from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import { ReactFCC } from '../../interface/react';
import UserGrid from '../../components/UserGrid/UserGrid';
import useSearch from './useSearch';
import { MemberView } from './interface';

interface SearchProps {}

const Search: ReactFCC<SearchProps> = () => {
	const { members, memberView, setMemberView } = useSearch();

	const changeListType = (type: MemberView) => {
		setMemberView(type);
	};

	return (
		<div data-testid="search-component">
			<Box textAlign="right" my={2}>
				<ButtonGroup variant="outlined" aria-label="outlined primary button group">
					<Button
						variant={memberView === MemberView.GRID ? 'contained' : 'outlined'}
						size="small"
						onClick={() => changeListType(MemberView.GRID)}
					>
						<ViewModuleIcon fontSize="small" />
					</Button>
					<Button
						variant={memberView === MemberView.LIST ? 'contained' : 'outlined'}
						size="small"
						onClick={() => changeListType(MemberView.LIST)}
					>
						<ViewListIcon fontSize="small" />
					</Button>
				</ButtonGroup>
			</Box>
			{memberView === 'grid' ? <UserGrid users={members} /> : 'list'}
			<Box
				sx={{
					my: {
						xs: 2,
						sm: 4,
						md: 5,
					},
					textAlign: 'center',
				}}
			>
				<Button variant="outlined" size="large" endIcon={<NavigateNextIcon />}>
					Next Page
				</Button>
			</Box>
		</div>
	);
};

export default Search;
